import {analyticsLogEvent} from '../api'

export function analyticsEventMinicartLayer() {
    const eventName = 'minicart_layer'

    analyticsLogEvent(eventName, {})
}
